







/* General */
import Vue from 'vue'
import logoSrc from '@/assets/img/logos/logo-donedone.svg'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default Vue.extend({
  name: 'TicketPortalFooter',

  components: {},

  data() {
    return {
      logo: {
        src: logoSrc,
        alt: 'Logo DoneDone',
      },
    }
  },
})
